// extracted by mini-css-extract-plugin
export default {"title":"home_title__cojxH","logo":"home_logo__dqN1T","innerTitleBox":"home_innerTitleBox__0fvhj"};